<template>
    <div class="modal fade" id="editTaskModal" tabindex="-1" role="form" aria-labelledby="editTaskModal"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <form method="post" :action="update_route" ref="editForm">
                    <input type="hidden" name="_token" v-bind:value="csrf">
                    <input type="hidden" name="is_admin" :value="is_admin">
                    <div class="modal-header">
                        <h5 class="modal-title" id="editTaskModalTitle">{{ $lang('Edycja zgłoszenia') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" :aria-label="$lang('Zamknij')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="can_edit_task">
                            <div class="col-12 form-group">
                                <label for="status">{{ $lang('Status') }}</label>
                                <jira-status-select v-model="status" :statuses="statuses" :admin_mode="is_admin">
                                </jira-status-select>
                            </div>
                            <template v-if="is_admin">
                                <div class="col-lg-6 col-md-12 col-12 form-group">
                                    <label for="category">{{ $lang('Kategoria') }}</label>
                                    <div class="input-group mb-2">
                                        <select id="category" name="category_id" class="form-control" v-model="category">
                                            <option :value="null">{{ $lang('Brak') }}</option>
                                            <option v-for="categoryOption in categories" :value="categoryOption.id">
                                                {{ categoryOption.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-12 col-12 form-group">
                                    <label for="criterion">{{ $lang('Kryterium') }}</label>
                                    <div class="input-group mb-2">
                                        <select id="criterion" name="criterion" class="form-control" v-model="criterion">
                                            <option v-for="criterionOption in criteria" :value="criterionOption.id">
                                                {{ criterionOption.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-12 col-12 form-group">
                                    <label for="module">{{ $lang('Moduł') }}</label>
                                    <div class="input-group mb-2">
                                        <select id="module" name="module" class="form-control" v-model="module">
                                            <option v-for="moduleOption in modules" :value="moduleOption.module_id">
                                                {{ moduleOption.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-12 col-12 form-group">
                                    <label for="consultant">{{ $lang('Osoba odpowiedzialna') }}</label>
                                    <div class="input-group mb-2">
                                        <select id="consultant" name="consultant_id" class="form-control"
                                                v-model="consultant">
                                            <option v-for="consultantOption in consultants" :value="consultantOption.id">
                                                {{ consultantOption.name + ' ' + consultantOption.surname }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="isPayable" class="col-lg-6 col-md-12 col-12 form-group">
                                    <label for="paid">{{ $lang('Płatne') }}</label>
                                    <div class="input-group mb-2">
                                        <select id="paid" name="paid" class="form-control" v-model="paid">
                                            <option value="0">{{ $lang('Nie') }}</option>
                                            <option value="1">{{ $lang('Tak') }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="isValuable" class="col-lg-6 col-md-12 col-12 form-group">
                                    <label for="valuation">{{ $lang('Wycena') }}</label>
                                    <div class="input-group mb-2">
                                        <input type="text" class="form-control" name="valuation" id="valuation"
                                               autocomplete="chrome-off" v-model="valuation">
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="project==='BPH'">
                                <div class="col-12 form-group">
                                    <label for="tester">{{ $lang('Tester') }}</label>
                                    <div class="input-group mb-2">
                                        <input type="text" class="form-control" name="details[tester]" id="tester"
                                               autocomplete="chrome-off" v-model="tester">
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-12 col-12 form-group">
                                    <label for="package_accepted">{{ $lang('Akceptacja wdrożenia') }}</label>
                                    <div class="input-group mb-2">
                                        <input type="text" class="form-control" name="details[package_accepted]" id="package_accepted"
                                               autocomplete="chrome-off" v-model="package_accepted">
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-12 col-12 form-group">
                                    <datepicker-accessible
                                        :label-single="$lang('Data akceptacji')"
                                        custom-id="package_accepted_at"
                                        name="package_accepted_at"
                                        mode="date"
                                        :use_pencil_checkbox="false"
                                        :strong_label="false"
                                        v-model="package_accepted_at"
                                        :is_required="false"
                                    ></datepicker-accessible>
                                    <input hidden type="date" class="form-control" name="details[package_accepted_at]" id="package_accepted_at"
                                           autocomplete="chrome-off" v-model="package_accepted_at">
                                </div>
                            </template>
                        </div>
                        <div class="row" v-if="project==='BPH'">
                            <input type="hidden" :name="'dora_values'" value="">
                            <div class="col-12">
                                <div class="form-group" :ref="'doraClassification'">
                                    <input type="hidden" :name="'dora_values[dora_classification]'" value="">
                                    <label for="doraClassification">{{ $lang('Klasyfikacja DORA') }}</label>
                                    <div class="form-check" v-for="doraClassification in dora_classification_types">
                                        <input
                                            type="checkbox"
                                            :id="'doraValues[doraClassification]['+doraClassification.value+']'"
                                            :name="'dora_values[dora_classification][]'"
                                            :value="doraClassification.value"
                                            v-model="doraValues.doraClassification"
                                        ></input>
                                        <label :for="'doraValues[doraClassification]['+doraClassification.value+']'">{{doraClassification.title}}</label>
                                    </div>
                                </div>
                                <div class="form-group" :ref="'occurrenceIdentification'">
                                    <label for="occurrenceIdentification">{{ $lang('Identyfikacja wystąpienia') }}</label>
                                    <input type="hidden" :name="'dora_values[occurrence_identification]'" value="">
                                    <label class="form-check" v-for="occurrenceIdentification in occurrence_identification_types">
                                        <input
                                            type="radio"
                                            :id="'doraValues[occurrenceIdentification]['+occurrenceIdentification.value+']'"
                                            :name="'dora_values[occurrence_identification]'"
                                            :value="occurrenceIdentification.value"
                                            v-model="doraValues.occurrenceIdentification"
                                        ></input>
                                        {{occurrenceIdentification.title}}
                                    </label>
                                </div>
                                <div class="form-group" :ref="'doraComment'">
                                    <label for="doraComment">{{ $lang('Komentarz DORA') }}</label>
                                    <textarea class="form-control" id="doraValues[doraComment]" name="dora_values[dora_comment]" rows="5"
                                              v-model="doraValues.doraComment">
                                    </textarea>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-12">
                                        <div class="form-group" :ref="'problemOccurrenceDate'">
                                            <datepicker-accessible
                                                id="problemOccurrenceDate"
                                                :label-single="$lang('Data wystąpienia problemu')"
                                                custom-id="problemOccurrenceDate"
                                                name="problemOccurrenceDate"
                                                mode="datetime"
                                                :use_pencil_checkbox="false"
                                                :strong_label="false"
                                                v-model="doraValues.problemOccurrenceDate"
                                                class="mt-0"
                                                :has_error="doraErrors.problemOccurrenceDateGreaterThanToday"
                                            ></datepicker-accessible>
                                            <span class="text-danger mt-1 mb-3">
                                                <small v-if="doraErrors.problemOccurrenceDateGreaterThanToday">
                                                    {{$lang('Data i godzina nie mogą być późniejsze niż teraz')}}
                                                </small>
                                            </span>
                                            <input type="hidden" name="dora_values[problem_occurrence_date]" :value="doraValues.problemOccurrenceDate"></input>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-12">
                                        <div class="form-group" :ref="'systemRestoreDate'">
                                            <datepicker-accessible
                                                id="systemRestoreDate"
                                                :label-single="$lang('Data przywrócenia systemu')"
                                                custom-id="systemRestoreDate"
                                                name="systemRestoreDate"
                                                mode="datetime"
                                                :use_pencil_checkbox="false"
                                                :strong_label="false"
                                                v-model="doraValues.systemRestoreDate"
                                                class="mt-0"
                                                :has_error="doraErrors.laterDateError || doraErrors.systemRestoreDateGreaterThanToday"
                                            ></datepicker-accessible>
                                            <span class="text-danger mt-1 mb-3">
                                                <small v-if="doraErrors.laterDateError">
                                                    {{$lang('Data przywrócenia systemu nie może być wcześniejsza niż data wystąpienia problemu')}}
                                                </small>
                                                <small v-else-if="doraErrors.systemRestoreDateGreaterThanToday">
                                                    {{$lang('Data i godzina nie mogą być późniejsze niż teraz')}}
                                                </small>
                                            </span>
                                            <input type="hidden" name="dora_values[system_restore_date]" :value="doraValues.systemRestoreDate"></input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="can_edit_task && commentable">
                            <div class="col-12 form-group">
                                <template v-if="is_admin">
                                    <label for="author_id">{{ $lang('Autor komentarza') }}</label>
                                    <div class="input-group mb-2">
                                        <select id="author_id" name="author_id" class="form-control" v-model="author">
                                            <option v-for="consultantOption in consultants" :value="consultantOption.id">
                                                {{ consultantOption.name + ' ' + consultantOption.surname }}
                                            </option>
                                        </select>
                                    </div>
                                    <label for="pre_comment">{{ $lang('Szablon komentarza') }}</label>
                                    <select class="form-control mb-3"
                                            id="pre_comment"
                                            name="pre_comment"
                                            type="text"
                                            v-model="preComment">
                                        <option value="">{{ $lang('Wybierz...') }}</option>
                                        <option v-for="element in pre_comments" :value="element"
                                                :selected="element === preComment">{{ element.name }}
                                        </option>
                                    </select>
                                </template>
                                <label for="comment">{{ $lang('Komentarz do zgłoszenia') }}
                                    <small class="text-red small-70" v-if="comment_needed || !is_admin">({{
                                            $lang('wymagane')
                                        }})</small>
                                </label>
                                <textarea class="form-control mb-3"
                                          id="comment"
                                          name="comment"
                                          v-model="comment"
                                          rows="5"
                                          :disabled="!author">{{commentContent}}
                                </textarea>
                                <input type="hidden" name="author_id" id="author_id_hidden" v-model="author">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default"
                                data-dismiss="modal">{{ $lang('Anuluj') }}
                        </button>
                        <button type="button" class="btn btn-primary" :disabled="!validForm" @click.once="submit">
                            {{ $lang('Zapisz') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import jiraStatusSelect from "../../jira-status-select";
import moment from "moment";
import DatepickerAccessible from "../../datepicker-accessible.vue";

export default {
    name: "edit-task-modal",
    components: {DatepickerAccessible, jiraStatusSelect},
    props: {
        project: {required: true, type: String},
        update_route: {required: true, type: String},
        csrf: {required: true},
        is_admin: {required: true, type: Boolean},
        user: {required: true, type: Object},
        task: {required: true, type: Object},
        statuses: {required: true, type: Array | Object | null},
        categories: {required: false, type: Array | Object | null, default: null},
        criteria: {required: false, type: Array | Object | null, default: null},
        modules: {required: false, type: Array | Object | null, default: null},
        consultants: {required: false, type: Array | Object | null, default: null},
        pre_comments: {required: false, type: Array | Object | null, default: null},
        required_comment_statuses: {required: true, type: Array|Object},
        dora_classification_types: {required: false, type: Array, default: []},
        occurrence_identification_types: {required: false, type: Array, default: []},
        can_edit_task: {required: true, type: Boolean}
    },
    data() {
        return {
            status: null,
            category: null,
            criterion: null,
            module: null,
            consultant: null,
            comment: null,
            commentable: false,
            comment_needed: false,
            paid: false,
            valuation: '',
            tester: '',
            package_accepted: '',
            package_accepted_at: '',
            author: null,
            preComment: null,
            requiredCommentStatuses: [],
            doraValues: {
                doraClassification: [],
                occurrenceIdentification: null,
                doraComment: null,
                problemOccurrenceDate: null,
                systemRestoreDate: null
            },
            doraErrors: {
                laterDateError: false,
                problemOccurrenceDateGreaterThanToday: false,
                systemRestoreDateGreaterThanToday: false
            }
        }
    },
    created() {
        if (this.task) {
            this.status = this.task.jira_status;
            this.category = this.task.category_id;
            this.criterion = this.task.criterion;
            this.module = this.task.module;
            this.consultant = this.task.consultant_id;
            this.author = this.task.consultant_id;
            this.paid = Boolean(this.task.paid) ? '1' : '0';
            this.valuation = this.task.valuation;
            this.tester = this.task.details?.tester ?? '';
            this.package_accepted = this.task.details?.package_accepted ?? '';
            this.package_accepted_at = this.task.details?.package_accepted_at ?? '';
            if (this.task.dora_values) {
                this.doraValues.doraClassification = this.task.dora_values.dora_classification ?? [];
                this.doraValues.occurrenceIdentification = this.task.dora_values.occurrence_identification;
                this.doraValues.doraComment = this.task.dora_values.dora_comment;
                this.doraValues.problemOccurrenceDate = this.task.dora_values.problem_occurrence_date;
                this.doraValues.systemRestoreDate = this.task.dora_values.system_restore_date;
            }
        }
        this.requiredCommentStatuses = this.statuses.filter(status => {
            return Boolean(this.required_comment_statuses.find(requiredCommentStatus => {
                return requiredCommentStatus === status.sos_id;
            }));
        })?.map(status => {
            return status.jira_id;
        });
        if (!this.is_admin) {
            this.author = this.user.id;
        }
    },
    methods: {
        submit() {
            this.$refs.editForm.submit();
        }
    },
    watch: {
        status() {
            this.commentable = false;
            this.comment_needed = false;
            if (this.task.jira_status !== this.status) {
                this.commentable = true;
                this.comment_needed = this.requiredCommentStatuses.includes(this.status);
            }
        }
    },
    computed: {
        validForm() {
            return (this.comment_needed ? Boolean(this.comment) : true) && (this.consultant || !this.is_admin)
                && this.areDoraDatesValid;
        },
        isPayable() {
            let tmp = this.criteria?.filter(x => x.id === this.criterion);
            if (tmp?.length === 1) {
                return tmp[0].payable;
            }

            return false;
        },
        isValuable() {
            let tmp = this.criteria?.filter(x => x.id === this.criterion);
            if (tmp?.length === 1) {
                return tmp[0].valuable;
            }

            return false;
        },
        commentContent() {
            if (this.preComment) {
                if (this.comment) {
                    this.comment = this.preComment.content + '\n' + this.comment;
                } else {
                    this.comment = this.preComment.content;
                }
                this.preComment = '';
                return this.comment;
            }
            this.preComment = '';
        },
        areDoraDatesValid() {
            this.doraErrors.laterDateError = false;
            this.doraErrors.systemRestoreDateGreaterThanToday = false;
            this.doraErrors.problemOccurrenceDateGreaterThanToday = false;
            let isValid = true;
            let today = Date.now();
            if (this.doraValues.systemRestoreDate) {
                let systemRestoreChosenDate = Date.parse(this.doraValues.systemRestoreDate);

                if (!systemRestoreChosenDate) {
                    isValid = false;
                }
                if (systemRestoreChosenDate && systemRestoreChosenDate > today) {
                    isValid = false;
                    this.doraErrors.systemRestoreDateGreaterThanToday = true;
                }
                if (systemRestoreChosenDate && this.doraValues.problemOccurrenceDate) {
                    let problemOccurrenceDate = Date.parse(this.doraValues.problemOccurrenceDate);

                    if (problemOccurrenceDate > systemRestoreChosenDate) {
                        isValid = false;
                        this.doraErrors.laterDateError = true;
                    }
                }
            }
            if (this.doraValues.problemOccurrenceDate) {
                let problemOccurrenceChosenDate = Date.parse(this.doraValues.problemOccurrenceDate);

                if (!problemOccurrenceChosenDate) {
                    isValid = false;
                }
                if (problemOccurrenceChosenDate && problemOccurrenceChosenDate > today) {
                    isValid = false;
                    this.doraErrors.problemOccurrenceDateGreaterThanToday = true;
                }
            }

            return isValid;
        }
    }
}
</script>
